import React from 'react';
import { PictureForm } from '../../../inventory/common';
import {Multilingual, TextInput, Modal, CheckBox } from 'hyperdb-utils';
const MultilingualTextInput = Multilingual(TextInput);

const MetadataTab = ({
  objectData, websiteContent = {}, availableLocales, onChange,
  toggleModalPicture, showModalPicture = false, editedPicture, toggleModalDeletePicture, showModalDeletePicture = false,
  onChangePicture, onUploadPicture, onDeletePicture, uploadingPicture = false, deletingPicture = false, typePicture,
  defaultLanguage, availableLanguages,
}) => {
  const handleChange = (attributeName, field) => {
    const content = { ...websiteContent };
    content[attributeName] = field.value;
    onChange(content);
  };
  const handleChangeLocalized = (attributeName, field) => {
    const { name, value } = field;
    handleChange(attributeName, { value: { $i18n: value } });
  };
  const handleClickCheckbox = (attributeName) => {
    const value = !websiteContent[attributeName];
    handleChange(attributeName, { value });
  };
  const localizedValue = (attributeName) => {
    return (websiteContent[attributeName] || {}).$i18n;
  };
  return (
    <fieldset>
      <MultilingualTextInput
        label="Meta title"
        name="page_meta_title"
        value={ localizedValue('page_meta_title') }
        onChange={ handleChangeLocalized.bind(null, 'page_meta_title') }
        availableLocales={ availableLocales }
      />
      <MultilingualTextInput
        label="Meta description"
        name="page_meta_description"
        value={ localizedValue('page_meta_description') }
        onChange={ handleChangeLocalized.bind(null, 'page_meta_description') }
        availableLocales={ availableLocales }
      />
      <CheckBox
        label="Use custom slug"
        name="use_custom_slug"
        checked={ websiteContent.use_custom_slug }
        onChange={ handleClickCheckbox.bind(null, 'use_custom_slug') }
      />
      {
        websiteContent.use_custom_slug
          ? <MultilingualTextInput
              label="Slug"
              name="page_slug"
              value={ localizedValue('page_slug') }
              onChange={ handleChangeLocalized.bind(null, 'page_slug') }
              availableLocales={ availableLocales }
            />
          : null
      }
      {/*
        objectData.id
          ? <div>
              <fieldset>
                <legend>Home page</legend>
                <h4>
                  Horizontal image
                  &nbsp; {
                    !websiteContent.horizontal_image
                      ? <button type="button" className="btn btn-primary btn-xs" onClick={toggleModalPicture.bind(null, true, 'horizontal')}>Add</button>
                      : null
                  }
                </h4>
                {
                  websiteContent.horizontal_image && websiteContent.horizontal_image.original
                    ? <div>
                        { websiteContent.horizontal_image.original.value.name }
                        &nbsp; <button type="button" className="btn btn-primary btn-xs" onClick={toggleModalPicture.bind(null, true, 'horizontal')}>Edit</button>
                        &nbsp; <button type="button" className="btn btn-danger btn-xs" onClick={toggleModalDeletePicture.bind(null, true, 'horizontal')}>Delete</button>
                      </div>
                    : null
                }
                <hr/>
                <h4>
                  Vertical image
                  &nbsp; {
                    !websiteContent.vertical_image
                      ? <button type="button" className="btn btn-primary btn-xs" onClick={toggleModalPicture.bind(null, true, 'vertical')}>Add</button>
                      : null
                  }
                </h4>
                {
                  websiteContent.vertical_image && websiteContent.vertical_image.original
                    ? <div>
                        { websiteContent.vertical_image.original.value.name }
                        &nbsp; <button type="button" className="btn btn-primary btn-xs" onClick={toggleModalPicture.bind(null, true, 'vertical')}>Edit</button>
                        &nbsp; <button type="button" className="btn btn-danger btn-xs" onClick={toggleModalDeletePicture.bind(null, true, 'vertical')}>Delete</button>
                      </div>
                    : null
                }
              </fieldset>
              {
                showModalPicture
                  ? <Modal title="" onClose={ toggleModalPicture.bind(null, false) } onAccept={ onUploadPicture } loading={ uploadingPicture }>
                      <PictureForm
                        object={ objectData }
                        picture={ editedPicture }
                        mode="short"
                        backendEntryPoint="/property-contents"
                        onChange={ onChangePicture }
                        uploadingPicture={ uploadingPicture }
                        defaultLanguage={ defaultLanguage }
                        availableLanguages={ availableLanguages }
                      />
                    </Modal>
                  : null
              }
              {
                showModalDeletePicture
                  ? <Modal title="" onClose={ toggleModalDeletePicture.bind(null, false) } onAccept={ onDeletePicture } loading={ deletingPicture }>
                      Delete this picture ?
                      <br/>
                      { deletingPicture ? 'DELETING...' : '' }
                    </Modal>
                  : null
              }
              <br/><br/>
            </div>
          : null
      */}
    </fieldset>
  );
};

export default MetadataTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-content/components/MetadataTab.jsx